import { ChefHat, ClipboardList, Store } from 'lucide-react';

import { OrderMobileStep } from '../orderPresentation';

interface OrdersMobileNavProps {
  step: OrderMobileStep;
  onStepChange: (step: OrderMobileStep) => void;
}

const steps = [
  ['TABLES', Store, 'Mesas'],
  ['MENU', ChefHat, 'Menú'],
  ['ORDER', ClipboardList, 'Orden'],
] as const;

const OrdersMobileNav = ({ step, onStepChange }: OrdersMobileNavProps) => {
  return (
    <nav className="grid grid-cols-3 border-b border-stroke dark:border-strokedark xl:hidden">
      {steps.map(([value, Icon, label]) => (
        <button
          type="button"
          key={value}
          onClick={() => onStepChange(value)}
          className={`inline-flex items-center justify-center gap-2 py-3 text-sm font-medium ${
            step === value
              ? 'border-b-2 border-primary text-primary'
              : 'text-bodydark2'
          }`}
        >
          <Icon className="h-4 w-4" />
          {label}
        </button>
      ))}
    </nav>
  );
};

export default OrdersMobileNav;
